import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { navigate, getQueryParam } from '../../utils/navigation';

const Login = () => {
  const { login, isAuthenticated } = useAuth();
  const from = getQueryParam('from');

  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  // Load login-styles.css dynamically and set html/body styles
  useEffect(() => {
    // Add login-styles.css
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = '/assets/css/login-styles.css';
    link.id = 'login-styles';
    document.head.appendChild(link);

    // Set html overflow hidden
    const originalOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';

    // Set body background image (matching original design CSS)
    const originalBodyBgImage = document.body.style.backgroundImage;
    const originalBodyBgRepeat = document.body.style.backgroundRepeat;
    const originalBodyBgPosition = document.body.style.backgroundPosition;
    const originalBodyBgSize = document.body.style.backgroundSize;

    document.body.style.backgroundImage = "url('/assets/images/banner1.png')";
    document.body.style.backgroundRepeat = 'no-repeat';
    document.body.style.backgroundPosition = 'left';
    document.body.style.backgroundSize = '90% 90%';

    // Cleanup on unmount
    return () => {
      const loginStyles = document.getElementById('login-styles');
      if (loginStyles) {
        loginStyles.remove();
      }
      document.documentElement.style.overflow = originalOverflow;
      document.body.style.backgroundImage = originalBodyBgImage;
      document.body.style.backgroundRepeat = originalBodyBgRepeat;
      document.body.style.backgroundPosition = originalBodyBgPosition;
      document.body.style.backgroundSize = originalBodyBgSize;
    };
  }, []);

  // Check if user is already authenticated
  useEffect(() => {
    if (isAuthenticated) {
      // Redirect to intended page or print page
      const redirectTo = from || '/prenup/PreMarriageSheet/MarriageIndex?IsPrint=True';
      navigate(redirectTo);
    }
  }, [isAuthenticated, from]);

  // Display error as alert (matching original design)
  useEffect(() => {
    if (error) {
      alert(error);
    }
  }, [error]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    // Clear error when user starts typing
    if (error) {
      setError('');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.username || !formData.password) {
      setError('يرجى إدخال اسم المستخدم وكلمة المرور');
      return;
    }

    setIsLoading(true);
    setError('');

    const result = await login({
      username: formData.username,
      password: formData.password
    });

    if (result.success) {
      // Navigate to intended page or print page
      const redirectTo = from || '/prenup/PreMarriageSheet/MarriageIndex?IsPrint=True';
      navigate(redirectTo);
    } else {
      setError(result.message);
    }

    setIsLoading(false);
  };

  return (
    <div className="wrapper">
      <div className="row" dir="ltr">
        <div className="col-md-7"></div>
        <div dir="rtl" className="col-md-5">
          <div className="login-block">
            <div className="login-content">
              <form onSubmit={handleSubmit} className="form-horizontal">
                <div className="titleDiv">
                  <div style={{ display: 'flex' }} className="row">
                    <div className="col-lg-6">
                      <img
                        src="/assets/images/logo-ar-black.png"
                        alt="وزارة الصحة والسكان"
                        style={{ marginRight: '10px', width: '100%' }}
                      />
                    </div>
                    <div className="col-lg-6" style={{ textAlign: 'end' }} id="Oncology" hidden>
                      <img
                        style={{ marginLeft: '10px', width: '95%' }}
                        src="/assets/images/OncLogo.png"
                        alt="مبادرة الكشف المبكر وعلاج الأورام السرطانية"
                      />
                    </div>
                  </div>
                  <h1 id="app_title">
                    مبادرة السيد رئيس الجمهورية لفحص المقبلين على الزواج
                  </h1>
                </div>

                <div className="login-form">
                  <h2>تسجيل الدخول</h2>

                  <div className="form-group">
                    <input
                      className="form-control"
                      id="UserName"
                      name="username"
                      placeholder="اسم المستخدم"
                      required
                      type="text"
                      value={formData.username}
                      onChange={handleInputChange}
                      disabled={isLoading}
                    />
                    <span className="field-validation-valid text-danger"></span>
                  </div>

                  <div className="form-group">
                    <input
                      className="form-control"
                      id="Password"
                      name="password"
                      placeholder="كلمة المرور"
                      required
                      type="password"
                      value={formData.password}
                      onChange={handleInputChange}
                      disabled={isLoading}
                    />
                    <span className="field-validation-valid text-danger"></span>
                  </div>

                  <div className="text-center">
                    <button className="btn btn-primary" type="submit" disabled={isLoading}>
                      {isLoading ? 'جاري تسجيل الدخول...' : 'تسجيل دخول'}
                    </button>
                  </div>
                  <br />
                </div>
              </form>
            </div>
            <br />
            <div className="login-footer" style={{ overflowY: 'auto', position: 'fixed', bottom: '0%' }}>
              <div className="copyright" style={{ background: 'grey' }}>
                <div>
                  <a href="http://www.dmsegypt.net/" target="_blank" rel="noopener noreferrer">
                    <img src="/assets/images/dms-logo.png" alt="DMS Egypt" />
                  </a>
                </div>
                <div>
                  <p style={{ color: 'black' }}>All Rights Reserved Version 2025 - DMS Egypt - Version 16.0</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
